export default class SpecialOffer {
  constructor (data) {
    if (!data || !data.id || !data.service || !data.label) throw new Error('Wrong Special Offer data')

    this.id = data.id
    this.label = data.label
    this.service = data.service
    this.price = data.price || 0
    this.oldPrice = data.old_price || 0
    this.special = data.special || null
  }
}
